export const text1 = `■件名
銀行勘定系システムの基幹サーバ開発案件

■案件概要
銀行勘定系システムの基幹サーバ開発/設計/テスト業務
既存機能の改修業務

■開発環境
言語：Java、Typescript
フレームワーク：Spring framework、Vue.js
DB：PostgreSQL
OS：Windows
その他：Git、Docker、VS Code、Slack

■必須スキル
・Java 〇年以上
・Spring Framework 〇年以上
・Git

■尚可スキル
・Typescript（Javascript）
・Vue.js
・上流工程の経験
・金融業界での業務経験

■求める人物像
・コミュニケーション良好な方
・主体的に行動ができる方
・成長意欲のある方

■想定単価(単価幅があると調整しやすいです)
・〇万円～〇万円

■精算幅（精算幅と精算時の時給単価を記載してください。）
・固定 or 精算あり
・精算幅：〇〇〇時間～〇〇〇時間

■開始予定時期・期間
・20XX年XX月～、XXヶ月間

■就業場所・リモートワークの有無
・23区内（最寄駅）
・23区外（最寄駅）
・東京都外県名（最寄駅）
・リモートワーク併用可能（週〇回）

■打合せ回数
・〇〇回（web実施  or 対面実施）

■募集人数
・〇人

■備考
・PC貸与あり・なし
・基本作業時間 〇時～〇時
・支払いサイト：〇〇日`;

export const text2 = `■件名
金融機関様向けのAWSクラウド設計構築業務

■業務概要
金融機関様向けのAWSクラウド設計構築業務

■想定業務内容
・新規導入AWS基盤の各種インフラ設計/構築
・既存システムのAWS基盤エンハンス案件

■必須スキル
・AWSクラウド基盤でのインフラ設計・構築経験
・AWS CloudFormationを用いた構築自動化経験

■歓迎する知識・経験
・スクリプト開発経験
・データベースの運用・構築経験

■求める人物像
・柔軟な思考性をお持ちの方
・自発的に行動できる方
・勤怠良好の方`;

export const text3 = `■件名
既存システムのインフラ基盤更改案件対応

■業務概要
既存システムのインフラ基盤更改案件対応

■想定業務内容
・新規システム構築に各種インフラ要件定義、設計
・既存システムの構成把握、技術検証

■必須スキル
・インフラ要件定義/基本設計の経験(3年以上)
・要件ヒアリング/顧客折衝の経験
・クラウド環境(AWS、Azure、GCPなど)の設計/構築経験

■歓迎する知識・経験
・Kubernetesでの環境構築経験
・Prometheusを用いた監視環境構築経験
・ELK環境構築経験

■求める人物像
・柔軟な思考性をお持ちの方
・自発的に行動できる方
・キャッチアップ力の高い方
・勤怠良好の方

■想定単価
・スキル見合い（下限：140H）

■参画時期
・即日～

■就業場所
・東京23区

■リモートワーク
・週2～3日はリモートワーク可能。
※立ち上がり期間(1ヶ月程度)は出社頻度多めとなります。`;